import React, { useEffect, useState } from "react";
import MijnAanvragenTable from "./MijnAanvragenTable";
import config from "../config";   // ✅ config import
import TerugNaarHomeButton from "../components/ui/TerugNaarHomeButton";
import PaginaLoader from "../components/PaginaLoader"; // ✅ toegevoegd

export default function MijnAanvragen() {
  const [aanvragen, setAanvragen] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const token = sessionStorage.getItem("access_token");

  useEffect(() => {
    const fetchAanvragen = async () => {
      try {
        const res = await fetch(`${config.API_URL}/mijnaanvragen`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        if (!res.ok) throw new Error("API-fout bij ophalen aanvragen");

        const data = await res.json();
        setAanvragen(Array.isArray(data) ? data : []);
        setError(null);
      } catch (err) {
        console.error("❌ Fout bij ophalen aanvragen:", err);
        setError(err.message);
        setAanvragen([]);
      } finally {
        setLoading(false);
      }
    };

    fetchAanvragen();
  }, [token]);

  // 🔑 Loader of foutmelding altijd fullscreen vóór de pagina
  if (loading) {
    return <PaginaLoader message="Mijn aanvragen worden geladen…" />;
  }
  if (error) {
    return <PaginaLoader message={`Fout bij laden aanvragen: ${error}`} />;
  }

  // ✅ Pas hier de echte pagina
  return (
    <div className="bg-white rounded-2xl shadow p-6 mt-6">
      <h1 className="text-2xl font-semibold mb-4">Mijn Aanvragen</h1>
      <MijnAanvragenTable aanvragen={aanvragen} />
      <TerugNaarHomeButton />
    </div>
  );
}
